import React, { useEffect, useContext, useState, useMemo, useRef } from "react";  
import websocket from "../helpers/WebSocket";
import Context from "../context/Context";
import TeamsContext from "../context/TeamsContext";

import {useNetworkingHooks} from "../helpers/NetworkMessaging";
import { useGameState, useTeamSelectionData } from "../helpers/TeamSelectionHooks";
import { hockeyTouchArea, GenericReticule, hockeyBkgSplash, hockeyLogo } from "../Sprites/ImagesLoader";
import {CoreGameConnectionsHooks} from "../helpers/CoreGameConnections_Hooks";
import { PageBackground, PlayerBanner } from "../Components/PagePrefabs";
import { TeamSelection } from "../Components/TeamSelectionPrefabs";
import { GameplayArea } from "../Components/GameplayPrefabs";


export default function Hockey(props){
    const context = useContext(Context);
    const teamsContext = useContext(TeamsContext);

    const useTeamSelectionDataContext = useTeamSelectionData();
    const TeamsRef = useRef();
    TeamsRef.current = useTeamSelectionDataContext.Teams;
    
    const useGameStatecontext = useGameState();
    const GameStateRef = useRef();
    GameStateRef.current = useGameStatecontext.GameState;

    const {SendSpecificMessageToServer, JoinWaitingRoom, Disconnect, CheckReconnectMessages, Reconnect} = useNetworkingHooks(context.user);
    const {CheckCoreGameConnectionMessages} = CoreGameConnectionsHooks(context.user, useGameStatecontext, useTeamSelectionDataContext);

    useEffect(() => {
        //OnMount Things happen here
        document.title = "Hockey Controller";

        websocket.AddListener(onPayload);
        window.addEventListener('beforeunload', handleTabClosing);
        //console.log(context.user);
        if(websocket.sessionId === '') Reconnect();
        //SendMessageToServer();
        document.addEventListener("touchmove", preventBehavior, {passive: false});

        //console.log(context.user.playerID);
        return () =>{
            //Unmount things happen here
            websocket.RemoveListener(onPayload);
            window.removeEventListener('beforeunload', handleTabClosing);
            document.removeEventListener("touchmove", preventBehavior, {passive: false});
        }
    }, []);

    const handleTabClosing = () => {
        Disconnect();
    }

   
    function onPayload(id, payload, senderContext){
        //console.log(`Payload message recieved ${id} ${payload}`)
        CheckCoreGameConnectionMessages(id, payload, senderContext);
        CheckReconnectMessages(id,payload, senderContext);

        //Game specific calls
        switch(id){
          
            default:
                break;
        }
    }
    function preventBehavior(e) {
        e.preventDefault(); 
    };

    function TrackingPosition(payload){
        SendSpecificMessageToServer("AirHockey_MovePaddle", payload);
    }

    function TrackingEnded(){
        SendSpecificMessageToServer("Hockey_FirePuck");
    }

    const TouchInfo = {
        bkg: hockeyTouchArea,
        reticule: GenericReticule,
        sendArray: false,
        rate: 15,
        onUpdateTracking: TrackingPosition,
        onTrackingEnd: TrackingEnded

    }

    return (

    <>
        <PageBackground bkgImage={hockeyBkgSplash} bkgStyle={{filter: 'blur(.125rem)'}} useBlur useLogo={!GameStateRef.current.joinedGame} Logo={hockeyLogo}/>
        <PlayerBanner myColor={teamsContext.Teams.myteam}/>
        {!GameStateRef.current.teamsSelected ? 
            <TeamSelection TeamContext={teamsContext} GameState={GameStateRef.current} smts={(msg) => SendSpecificMessageToServer(msg)} /> 
            : 
            <GameplayArea game="Hockey" Team={teamsContext.Teams.myteam} OpposingTeam={teamsContext.Teams.otherteam} TouchBoxInfo={TouchInfo} Spectating={teamsContext.Teams.myteam === teamsContext.Teams.neutralteam} Logo={hockeyLogo} />    
        }

    </>
       
    );
}
